import { BrowserRouter, Route, Routes, Navigate, useLocation, Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { RecoilRoot } from 'recoil';

import './assets/css/style.css';

import UserVocWritePage from './components/pages/UserVocWritePage';
import UserVocDetailPage from './components/pages/UserVocDetailPage';

import AdminVocBoardPage from './components/pages/AdminVocBoardPage';
import AdminVocDetailPage from './components/pages/AdminVocDetailPage';
import AdminServiceDetailPage from './components/pages/AdminServiceDetailPage';
import AdminVocLoginPage from './components/pages/AdminVocLoginPage';

// =========================
// Layout
// =========================
const AppWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

// =========================
// 관리자 레이아웃
// =========================
const AdminLayout = () => {
  const location = useLocation();
  const isAdmin = sessionStorage.getItem('isAdmin') === 'true';

  if (!isAdmin) {
    return <Navigate to="/AdminVocLogin" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

// =========================
// App
// =========================
function App() {
  return (
    <RecoilRoot>
      <AppWrapper>
        <BrowserRouter>
          <Routes>
            {/* =========================
                Public Routes
            ========================= */}
            <Route path="/" element={<UserVocWritePage />} />
            <Route path="/UserVocWrite" element={<UserVocWritePage />} />
            <Route path="/UserVocDetail" element={<UserVocDetailPage />} />
            <Route path="/AdminVocLogin" element={<AdminVocLoginPage />} />

            {/* =========================
                관리자 로그인 필요 Routes
            ========================= */}
            <Route element={<AdminLayout />}>
              <Route path="/AdminVocBoard" element={<AdminVocBoardPage />} />
              <Route path="/AdminVocDetail" element={<AdminVocDetailPage />} />
              <Route path="/AdminServiceDetail" element={<AdminServiceDetailPage />} />
            </Route>

            {/* =========================
                Fallback
            ========================= */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AppWrapper>
    </RecoilRoot>
  );
}

export default App;
